import moment from 'moment'
import { CHATS_LIST_TYPE } from '@/helpers/chat'

export default {
}
